import { lazy } from 'react';

const EditProgramGroupModal = lazy(
  () => import('./components/EditProgramGroupModal'),
);

const ProgramGroupTypeModal = lazy(
  () => import('./components/ProgramGroupTypeModal'),
);

const SequencePickerEditor = lazy(
  () => import('./CoursePickerV2/SequencePicker/SequenceModal'),
);

const BeforeYouAddCourseModal = lazy(
  () => import('modules/CourseOfferingsV2/modals/BeforeYouAddCourseModal'),
);

const ElectiveSequencePickerEditor = lazy(
  () => import('./CoursePickerV2/SequencePicker/ElectiveSequenceModal'),
);

const EditProgramSlotModalV2 = lazy(
  () =>
    import(
      './GraduationPlanDetailV2/components/GraduationPlanDetailContent/components/ProgramsSection/components/EditProgramSlotModalV2'
    ),
);

const RequirementFormModal = lazy(
  () =>
    import(
      './GraduationPlanDetailV2/components/GraduationPlanDetailContent/components/RequirementsSection/components/RequirementFormModal'
    ),
);

const ElectiveCoursesConfirmationModal = lazy(
  () =>
    import(
      './GraduationPlanDetailV2/components/GraduationPlanDetailContent/components/ElectivesSection/components/ElectiveCoursesConfirmationModal'
    ),
);

const RemoveRequirementConfirmationModal = lazy(
  () =>
    import(
      './GraduationPlanDetailV2/components/GraduationPlanDetailContent/components/GradPlanRequirementTree/components/RequirementActions/components/RemoveRequirement/components/RemoveRequirementConfirmationModal'
    ),
);

export default {
  COURSE_CATALOG_SEQUENCE_PICKER: SequencePickerEditor,
  COURSE_CATALOG_ELECTIVE_SEQUENCE_PICKER: ElectiveSequencePickerEditor,
  EDIT_PROGRAM_GROUP_MODAL: EditProgramGroupModal,
  PROGRAM_GROUP_TYPE_MODAL: ProgramGroupTypeModal,
  BEFORE_YOU_ADD_COURSE_MODAL: BeforeYouAddCourseModal,
  EDIT_PROGRAM_SLOT_MODAL_V2: EditProgramSlotModalV2,
  REQUIREMENT_FORM_MODAL: RequirementFormModal,
  ELECTIVE_COURSES_CONFIRMATION_MODAL: ElectiveCoursesConfirmationModal,
  REMOVE_REQUIREMENT_CONFIRMATION_MODAL: RemoveRequirementConfirmationModal,
};
